const Services = [



    {

        symbol: "/UR9DRINKS.png",
        sectionimg:"/NewCika.jpg",
        Headertext:"UR9 LIQUOR", 
        info: "Liquor",
        Textinfo: "UR9 Liquor is triple distilled from the finest blends of fruits that give ita unique flavor with an extremely smooth, fresh and fruity taste. UR9 Liquor is a commitment to superior taste, quality and a fun-loving lifestyle."
    ,   link:"/Ourbusiness"
    },

    {

        symbol: "/farmer.png",
        sectionimg:"/ur9agri.jpg",
        Headertext:"AGRI-BUSINESS & AGRO ALLIED SERVICES",
        info: "Agriculture",
        Textinfo: "Ur9 Agri-Business model is centered on efficient ways of planting, growing, harvesting, packaging and preserving food in a healthy way. We pride ourselves on how organic and healthy our products are.  Our aim is to help alleviate hunger and starvation both in Africa and around the globe",
        link:"/Ourbusiness"
    },


    {

        symbol: "/UR9ASSET.png",
        sectionimg:"/ur9lin1.JPG",
        Headertext:"ASSET MANAGEMENT",
        info: "Asset Management",
        Textinfo: "Our wealth of experience in Asset Management is invaluable.Fixed Asset Management, Enterprise  Asset Management are three (3) core areas where our clients areare assured of expertise."
        ,link:"/Ourbusiness"
    
    },


    {
        Headertext:"UR9 Logistics",
        sectionimg:"/transport.png",
        symbol: "/UR9TRANSPORT.png",
        info: "Transportation",
        Textinfo: " UR9 Transport has been innovative in its operation in the transportation industry. We have commenced the phasing out of our crude- powered automobiles to be replaced by solar and electric powered automobiles in line with the Climate Change Initiative.We firmly believe this will enhance the riding experience of our customers while promoting clean energy"
        ,link:"/Ourbusiness"
   
    },



    {
        Headertext:"CONSTRUCTION (PROPERTY DEVELOPMENT)",
        sectionimg:"/ur9consti.jpg",
        symbol: "/UR9CONST.png",
        info: "Construction",
        Textinfo: " UR9 Construction Ltd is a Design, Development & Construction Company and a member of the UR9 GROUP, UR9 Construction undertakes design, building and construction projects for Individuals, Private and Public Institutions and other Corporate Bodies as well as exceptional supervision of projects. UR9 Construction builds quality residential and commercial structures with great attention to functionality, space flow efficiency, structural stability, facade and finishing details. UR9 Construction is focused on revolutionizing the integration of Technology, Automation and Innovative Designs (T.A.I.D) into residential and commercial real estate using sustainable techniques. We place great emphasis on Prime Luxury, Elegance and Excellence for all our projects.",
   link:"/Ourbusiness"
   
    },
    {
        Headertext:"UR9 TECHNOLOGIES",
        sectionimg:"/ur9tech1.jpg",
        symbol: "/UR9TECH.png",
        info: "Technology",
        Textinfo: " UR9 Tech is a dynamic technology company dedicated to driving innovation and sustainability in the ever-evolving tech landscape. Our team of skilled professionals specializes in crafting transformative technologies that empower businesses, individuals. We're committed to creating solutions that not only meet today's demands but also sustain businesses for a brighter tomorrow.  UR9 Tech: Pioneering Innovation for Sustainable Success.",
   link:"/Ourbusiness"
   
    },


    {
        Headertext:"REAL ESTATE (PROPERTY MANAGEMENT)",
        sectionimg:"/E2.jpg",
        symbol: "/UR9PROP.png",
        info: "Real Estate",
        Textinfo: " UR9 Properties Ltd is a Real Estate Management Company and a member of the UR9 GROUP. With over 5 years in the Abuja real estate eco-system and having diligently understudied the market and can boast of premium experience in project delivery, marketing and branding as well as building general economic portfolio, UR9 Properties is a solid partner for real estate business in Abuja. There are very limited players in this field who understand and can deliver the taste of Abuja real estate investors like we can. UR9 Properties takes the burden off our clients and adds value by taking the lead from the first stage of development to its final stage (interior and exterior) whilst also providing top-notch project support services thus giving the client a premium quality experience on every project."
  ,link:"/Project"
  
    },


    {
        Headertext:"UR9 LEADERSHIP INSIGHT NETWORK",
        sectionimg:"/ur9lin.jpeg",
        symbol: "/ur9linlogo.png",
        info: "Ur9 Leadership Insight Network",
        Textinfo: "UR9 Leadership Insight Network is an exclusive community dedicated to nurturing leadership excellence across diverse industries and sectors. It serves as a dynamic hub where leaders, both established and emerging, come together to share experiences, exchange ideas, and learn from one another.",
        
  link:"/ur9lin"
  
    },

    
    {
        Headertext:"UR9 LUXURY FASHION HOUSE",
        sectionimg:"/ur9fashion.jpg",
        symbol: "/ur9fashionlogo.png",
        info: "UR9 Luxury Fashion House",
        Textinfo: "Step into a world of sophistication and glamour with UR9 Luxury Fashion. From runway-ready looks to timeless classics, our collection offers something for every fashionista. Get ready to elevate your wardrobe and make a statement wherever you go"+

        "Ready for a wardrobe refresh? UR9 Couture invites you to explore our latest collection of haute couture designs that are guaranteed to turn heads. From luxurious fabrics to exquisite detailing, each piece is a work of art. Get ready to be spellbound"+
        
       " Experience the artistry of fashion with UR9 Couture. Our collection showcases the creativity and craftsmanship of some of the industry's most talented designers. Get ready to be inspired and discover your signature style.",
        
  link:"https://ur9group.com/lfh/"
  
    },


    {
        Headertext:"UR9 INTERIORS",
        sectionimg:"/ur9interiordes.jpg",
        symbol: "/ur9interiors.png",
        info: "UR9 Interiors",
        Textinfo: "Ready for a change? UR9 Interiors is here to help you elevate your space to new heights of luxury and comfort. From chic furnishings to stunning décor, our team of designers will work tirelessly to bring your vision to life. Get ready to fall in love with your home all over again" +

        "Let UR9 Interiors be your guide to design excellence. With our team of talented designers and craftsmen, we'll help you bring your vision to life with precision and flair. Get ready to embark on a journey of creativity and inspiration – your dream space awaits"+
        
        "Ready to explore your unique sense of style? UR9 Interiors is here to help you discover the perfect look for your home. Whether your taste is modern and minimalist or classic and cozy, our designers will help you find the perfect balance. Get ready to express yourself like never before",
        
        
        
  link:"/Ourbusiness"
  
    },










    {
        Headertext:"UR9 EVENTS",
        sectionimg:"/ur9eventscover.jpg",
        symbol: "/ur9events.png",
        info: "UR9 Events",
        Textinfo: "Dream big, because anything is possible with UR9 Events! From fairy tale weddings to themed birthday parties, we specialize in turning dreams into reality. Join us as we embark on a magical journey filled with wonder, joy, and endless possibilities. Your dream event starts here."+

       "Moments become memories with UR9 Events! Whether you're planning a romantic wedding or a corporate retreat, our team is dedicated to ensuring every detail is perfect. Join us as we embark on a journey to create unforgettable moments that will be cherished for a lifetime. Let's make magic together"+
        
       " Ready to experience the extraordinary? UR9 Events invites you to join us for a series of exclusive events that promise to leave you spellbound. Whether you're seeking luxury, adventure, or romance, we've got the perfect experience waiting for you. Get ready to make memories that will last a lifetime",
        
        
  link:"/Ourbusiness"
  
    }



]

export default Services;